import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DropdownSizings, Href, LargeButton } from "../../../../Constant";
import { DIVIDER_DATA, SIZING_LIST } from "../../../../Data/UiKit/Dropdown";
import CommonDropDown from "../Common/CommonDropDown";

const DropdownSizing = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={DropdownSizings} span={DIVIDER_DATA} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="info" size="lg" className="text-white">{LargeButton}</DropdownToggle>
                <DropdownMenu className="dropdown-block">
                  <DropdownItem htef={Href}>Small button</DropdownItem>
                  <DropdownItem htef={Href}>Medium button</DropdownItem>
                  <DropdownItem htef={Href}>Large button</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem htef={Href}>Very large button </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {SIZING_LIST.map((data, index) => (
              <CommonDropDown key={index} item={data} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DropdownSizing;